import { z } from "zod";

export const userSchema = z
    .object({
        first_name: z.string().min(1, "First name is required"),
        middle_name: z.string().optional(),
        last_name: z.string().min(1, "Last name is required"),
        email: z.string().email("Please enter a valid email address"),
        phone: z.string().min(11, "Phone number must be at least 11 characters"),
        role: z.enum(["customer", "business_customer", "driver"]),
        avatar: z.string().optional(),
        address: z.string().optional(),
        origin_city: z.string().optional(),
        origin_latitude: z.number().optional(),
        origin_longitude: z.number().optional(),
    });

export type UserFormData = z.infer<typeof userSchema>;
